import { Component, input } from '@angular/core';
import { Activity } from '@mira-avant/mtlibs';
import { CommonModule } from '@angular/common';
import { CmsBadge } from '../cms-badge/cms-badge';

@Component({
	selector: 'app-skill-summary',
	imports: [CommonModule, CmsBadge],
	standalone: true,
	templateUrl: './skill-summary.html',
	styleUrl: './skill-summary.scss',
})
export class SkillSummary {
	activity = input.required<Activity>();
}
